// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"styles_loadingOverlay__ljSMj","noPermissionMessage":"styles_noPermissionMessage__7y8Du"};